import React from 'react';
import { BadgeCheck } from 'lucide-react';

// Reassurance message shown near Library links, Save buttons, resource/forms pages and downloads.
// Makes it explicit that the INASW Library is always free.
const LibraryFreeNote = ({ variant = 'pill', className = '' }) => {
  if (variant === 'banner') {
    return (
      <div
        className={`flex items-center justify-center gap-2 rounded-lg bg-secondary/10 border border-secondary/30 text-primary text-sm font-medium px-4 py-2 ${className}`}
        data-testid="library-free-note"
      >
        <BadgeCheck className="w-4 h-4 text-secondary shrink-0" />
        <span>The INASW Library is always free — you&rsquo;re never charged to save or access your materials.</span>
      </div>
    );
  }
  return (
    <p
      className={`inline-flex items-center gap-1 text-xs text-secondary font-medium ${className}`}
      data-testid="library-free-note"
    >
      <BadgeCheck className="w-3.5 h-3.5 shrink-0" />
      The INASW Library is always free.
    </p>
  );
};

export default LibraryFreeNote;
